<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Service Providers</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Register as a Professional</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="create-account-area pt-100 pb-100">
  <div class="container">
      <div class="create-photo">
          <div class="already-create">
              <h5 class="green">Register as a vetted professional service provider <i class="icofont-verification-check"></i></h5>
              <!-- <span></span> -->
          </div>
      </div>

      <div class="create-information">
        <form [formGroup]="sform" (ngSubmit)="saveData()">
            <h3>{{title}}</h3>

            <!-- This section willbe for future service/business cover photo -->
            <!-- <div class="create-information-btn">
                <a routerLink="/">Upload Cover Photo</a>
                <a routerLink="/">Upload Your CV</a>
            </div> -->

            <div class="row">

                 <div class="row">
                   <!-- Service Category -->
                   <div class="col-lg-6">
                    <div class="form-group">
                        <label for="serviceCategoryId">Service Category</label>
                        <ng-select
                        formControlName="serviceCategoryId"
                        [ngClass]="{'is-invalid': displayMessage.serviceCategoryId}"
                        [items]="categories"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                        <span class="invalid-feedback">
                          {{displayMessage.serviceCategoryId}}
                        </span>
                    </div>
                  </div>

                  <!-- Service Name -->
                  <div class="col-lg-6">
                    <div class="form-group">
                        <label for="name">Service Name</label>
                        <input type="text" class="form-control"
                        id="name" placeholder="service name or a person"
                        formControlName="name"
                        [ngClass]="{'is-invalid': displayMessage.name }">
                        <span class="invalid-feedback">
                          {{displayMessage.name}}
                        </span>
                    </div>
                  </div>

                 </div>

                 <div class="row">
                   <!-- Address Line -->
                   <div class="col-lg-6">
                    <div class="form-group">
                      <label for="line">Address:</label>
                        <input type="text" class="form-control"
                        id="line" placeholder="Service/Business address"
                        formControlName="line"
                        [ngClass]="{'is-invalid': displayMessage.line }">
                        <span class="invalid-feedback">
                          {{displayMessage.line}}
                        </span>
                    </div>
                  </div>

                  <!-- Country -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="city">Country:</label>
                      <ng-select
                          formControlName="country"
                          [ngClass]="{'is-invalid': displayMessage.country}"
                          [items]="countries"
                          bindLabel="name"
                          bindValue="shortName">
                          </ng-select>
                          <span class="invalid-feedback">
                            {{displayMessage.city}}
                          </span>
                    </div>
                  </div>
                 </div>

                <div *ngIf="country.value != null" class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="city">State:</label>
                      <ng-select
                          formControlName="state"
                          [ngClass]="{'is-invalid': displayMessage.state}"
                          [items]="states"
                          bindLabel="state"
                          bindValue="state">
                          </ng-select>
                          <span class="invalid-feedback">
                            {{displayMessage.city}}
                          </span>
                    </div>
                  </div>

                  <div *ngIf="state.value != null" class="col-lg-6">
                    <div class="form-group">
                      <label for="city">City:</label>
                      <ng-select
                          formControlName="city"
                          [ngClass]="{'is-invalid': displayMessage.city}"
                          [items]="cities"
                          bindLabel="city"
                          bindValue="city">
                          </ng-select>
                          <span class="invalid-feedback">
                            {{displayMessage.city}}
                          </span>
                    </div>
                  </div>
                </div>

                <div class="row">
                    <!-- Description -->
                    <div class="col-lg-6">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea id="your_message" class="form-control" rows="8"
                            formControlName="description"
                           placeholder="Decscribe the nature of your business or service"></textarea>
                      </div>
                    </div>

                    <!-- Contact Number -->
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="contactNumber">Your Phone</label>
                            <input type="text" class="form-control"
                            id="contactNumber" placeholder="08147526931"
                            formControlName="contactNumber"
                            [ngClass]="{'is-invalid': displayMessage.contactNumber }">
                            <span class="invalid-feedback">
                              {{displayMessage.contactNumber}}
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="text-left">
              <button type="submit" class="btn create-ac-btn"
                [title]="sform.valid"
                [disabled]="!sform.valid">
                Save</button>
            </div>

        </form>
    </div>


  </div>
</div>
